import React from 'react';
import { Rating } from 'react-simple-star-rating';
import { IUserReview } from '../../../constants/interface/IReview';
import './Review.scss';

interface IProps {
  reviews: Array<IUserReview>;
}

const Review = (props: IProps) => {
  return (
    <div className="property-reviews box-view h-auto user-profile-review">
      <div className="row">
        <div className="col-6">
          <h3 className="box-title">{props.reviews?.length} Review</h3>
        </div>
        {/* <div className="col-6">
          <ul className="nav nav-pills border-1 rounded-3 float-end p-1">
            <li className="nav-item">
              <a
                className="btn border-0 active"
                data-bs-toggle="tab"
                href="#AllReviews"
                onClick={() =>
                  setReviewTitle(
                    () => `${propertyDetail.review.length} Reviews`
                  )
                }
              >
                All Reviews
              </a>
            </li>
            {loggedUser?._id !== propertyDetail.user_id ? (
              <li className="nav-item">
                <a
                  className="btn"
                  data-bs-toggle="tab"
                  href="#WriteReview"
                  onClick={() => setReviewTitle(() => `Write a review`)}
                >
                  Write a review
                </a>
              </li>
            ) : (
              <></>
            )}
          </ul>
        </div> */}
      </div>
      <div className="row">
        <div className="col-12">
          <div className="tab-content">
            <div id="AllReviews" className="container tab-pane active">
              {props.reviews?.map((reviewDetail, i) => (
                <div className="d-flex mt-3" key={i}>
                  <div className="review-user-img">
                    <img
                      src={reviewDetail.userPicUrl}
                      alt="owner"
                      className="admin-img"
                    />
                  </div>
                  <div className="ms-3">
                    <div className="flex">
                      <h6 className='m-0'>{reviewDetail.name}</h6>
                      <div
                        style={{
                          paddingTop: '0px',
                          marginTop: '0px',
                        }}
                      >
                        <Rating
                          initialValue={reviewDetail.rating}
                          // onPointerEnter={()=>{}}
                          // onPointerLeave={()=>{}}
                          // onPointerMove={handleRating}
                          SVGstyle={{
                            display: 'inline',
                            height: '15px',
                            width: '15px',
                          }}
                          readonly={true}
                        />
                      </div>
                    </div>
                    <p>{reviewDetail.comment}</p>
                  </div>
                </div>
              ))}
            </div>
            {/* <div id="WriteReview" className="container tab-pane fade">
              {isReviewAdded?.length > 0 ? (
                <div>You have Already Written Review For This Property</div>
              ) : (
                <Formik
                  initialValues={{
                    propertyId: '',
                    userId: '',
                    reviewerName: '',
                    rating: 0,
                    title: '',
                    content: '',
                  }}
                  // validationSchema={CreateLisingSchema}
                  onSubmit={(values) => {
                    const user = JSON.parse(localStorage.getItem('user') ?? '');
                    const data = {
                      propertyId: currentPropertyId ?? values.propertyId,
                      userId: user._id ?? values.userId,
                      reviewerName: `${user.firstName} ${user.lastName}`,
                      rating: values.rating,
                      title: values.title,
                      content: values.content,
                    };

                    dispatch(
                      addReviewsProperty({
                        body: data,
                      }) as unknown as UnknownAction
                    );
                  }}
                >
                  {() => (
                    <div className="font-body">
                      <Form>
                        <div className="mb-3 flex">
                          <Field name="rating" as={FormikFieldStarRating} />
                        </div>

                        <div className="mb-3">
                          <label
                            htmlFor="exampleFormControlInput1"
                            className="form-label"
                          >
                            Title
                          </label>
                          <Field
                            type="text"
                            name="title"
                            id="exampleFormControlInput1"
                            placeholder=""
                            autoComplete="off"
                            className={`mt-2 form-control`}
                          />
                        </div>

                        <div className="mb-3">
                          <label
                            htmlFor="exampleFormControlTextarea1"
                            className="form-label"
                          >
                            Reviews
                          </label>
                          <Field
                            type="text"
                            name="content"
                            id="exampleFormControlTextarea1"
                            placeholder=""
                            autoComplete="off"
                            className={`mt-2 form-control`}
                            as={FormikFieldTextArea}
                          />
                        </div>

                        <button
                          className="btn btn-primary text-white"
                          type="submit"
                        >
                          Submit Review
                        </button>
                      </Form>
                    </div>
                  )}
                </Formik>
              )}
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Review;
